export default "__VITE_ASSET__DPWY7OcS__"